export default function createMarkup (html) {
  return { __html: html}
}


// WEBPACK FOOTER //
// ./src/helpers/bookPrint/createMarkup.js